import { render, staticRenderFns } from "./TextResponse.vue?vue&type=template&id=a8bcb302&"
import script from "./TextResponse.vue?vue&type=script&lang=ts&"
export * from "./TextResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports